import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Col, Container, Form, Row } from 'react-bootstrap';


export default function TeacherTiming(props) {
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
 
  const [timings, setTimings] = useState([]);
  const [dayParts, setDayParts] = useState([]);

  useEffect(() => {
      setLoading(true);
      var params = {login:util.getTrustedUser(), teacherId:util.getTrustedUser().userId};
      var url = config.Server+`/school/timing/teacher/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data.timings;
                  console.log("resopnse is> ", response[0].dayItems);
                  var dp = [];
                  for(var i=0;i<response[0].dayItems.length;i++){
                    dp.push({index:response[0].dayItems[i].timeIndex, title:response[0].dayItems[i].timePart})
                  }
                  setDayParts(dp);
                  setTimings(response);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setLoading(false);
          });
     
  }, []);

  return (
    <div>
      {
        loading?
        <>loading...</>
        :
        <>
        <Container fluid>
        <Row style={{overflow:"scroll", marginTop:"10px"}}>
          <table border="1" style={{borderCollapse:'collapse', width:'100%'}}>
            <thead>
              <tr>
                <td style={{textAlign:"center", width:"70px", padding:"5PX", border:"1px solid #b0b0b0"}}>روز</td>
                {
                  dayParts.map((zang) => {return (<td style={{textAlign:"center", backgroundColor:"#808080", color:"#fff", padding:"10px 5px"}}>{zang.title}</td>)})
                }              
              </tr>
            </thead>
            <tbody>
              {timings.map((day) => 
                <tr>
                  <td style={{textAlign:"center", padding:"5PX", border:"1px solid #b0b0b0"}}>{day.weekDayName}</td>
                  {
                  day.dayItems.map((col) => 
                    <td style={{padding:'10px', textAlign:'center', border:"1px solid #b0b0b0"}}>        
                          {
                            col.timePartItems.map((cls)=>{
                              return(
                                (cls.schoolClass != null)&&(cls.schoolClass2 == null)?
                                <div style={{border:"1px solid #02701eff", backgroundColor:"#daf7e3ff", color:"#000000", position:"relative"}}>
                                  {cls.schoolClass.name}
                                  <div style={{minWidth:"150px", border:"1px dashed #00e0e0", color:"#000000", position:"relative", height:"28px"}}>
                                    <div title={cls.schoolClass.name + " - " + cls.course.name} style={{position:"absolute", left:"25px", top:"2px", width:"calc(100% - 30px)", height:"22px", overflow:"hidden", textAlign:"center", fontSize:"8pt"}}>
                                      {cls.course.name}
                                    </div>
                                  </div>
                                </div>
                                :(cls.schoolClass != null)&&(cls.schoolClass2 != null)?
                                <>
                                <div style={{minWidth:"150px", border:"1px solid #faae82ff", backgroundColor:"#f7dbc5ff", color:"#000000", position:"relative"}}>
                                  {cls.schoolClass.name}
                                  <div style={{border:"1px dashed #00e0e0", color:"#000000", position:"relative", height:"28px"}}>
                                    <div title={cls.schoolClass.name + " - " + cls.course.name} style={{position:"absolute", left:"25px", top:"2px", width:"calc(100% - 30px)", height:"22px", overflow:"hidden", textAlign:"center", fontSize:"8pt"}}>
                                      {cls.course.name}
                                    </div>
                                  </div>
                                </div>
                                <div style={{minWidth:"150px", border:"1px solid #faae82ff", backgroundColor:"#f7dbc5ff", color:"#000000", position:"relative"}}>
                                  {cls.schoolClass2.name}
                                  <div style={{border:"1px dashed #00e0e0", color:"#000000", position:"relative", height:"28px"}}>
                                    <div title={cls.schoolClass2.name + " - " + cls.course2.name} style={{position:"absolute", left:"25px", top:"2px", width:"calc(100% - 30px)", height:"22px", overflow:"hidden", textAlign:"center", fontSize:"8pt"}}>
                                      {cls.course2.name}
                                    </div>
                                  </div>
                                </div>
                                </>
                                :<></>
                              )
                            })
                          }
                    </td>)
                  }
                </tr>)}
            </tbody>
          </table>
        </Row>
        </Container>
        </>
      }
    </div>
  );
}
